export class BrowserHelper {
  static checkIfChrome() {
    return (
      /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
    )
  }
}
